var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useNavigate, Link } from 'react-router-dom';
import { Container, IconButton, Toolbar as MuiToolbar, Box, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { BackIcon } from './Icons';
var Toolbar = styled(MuiToolbar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n"])));
var ToolbarTitle = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"], ["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"])));
var ToolbarActions = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"])));
var PageLayout = function (_a) {
    var backLink = _a.backLink, backLinkTo = _a.backLinkTo, title = _a.title, children = _a.children, className = _a.className, _b = _a.actions, actions = _b === void 0 ? null : _b;
    var navigate = useNavigate();
    var theme = useTheme();
    var size = useMediaQuery(theme.breakpoints.down('md')) ? 'small' : 'medium';
    var handleClickBack = React.useCallback(function () {
        navigate(-1);
    }, [navigate]);
    var handleBackLink = React.useCallback(function () {
        if (history.state.idx) {
            navigate(-1);
            return;
        }
        backLinkTo ? navigate(backLinkTo) : navigate(-1);
    }, [navigate, backLinkTo]);
    return (React.createElement(Container, { maxWidth: false, className: className },
        React.createElement(Toolbar, { disableGutters: true },
            React.createElement(ToolbarTitle, null,
                backLinkTo && !backLink && (React.createElement(IconButton, { component: Link, to: backLinkTo, size: size },
                    React.createElement(BackIcon, null))),
                !backLinkTo && backLink && (React.createElement(IconButton, { onClick: handleClickBack, size: size },
                    React.createElement(BackIcon, null))),
                backLinkTo && backLink && (React.createElement(IconButton, { onClick: handleBackLink, size: size },
                    React.createElement(BackIcon, null))),
                title && (React.createElement(Box, { component: "h4", sx: { typography: function (theme) { return theme.customTypography.h4; } } }, title))),
            React.createElement(ToolbarActions, null, actions)),
        children));
};
export default PageLayout;
var templateObject_1, templateObject_2, templateObject_3;
